import React, { useState, useEffect } from "react";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import {changedFields, initialActions, saveAvailable} from "../../../../recoil-store/recoil-state";
import {CheckIfFlowUpdated, isActionValueController} from "../../../../helpers/helper";
import {useRecoilValue, useSetRecoilState} from "recoil";


/**
 * @Description this page Active Directory  Library's   Add group  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */

export default function AddGroup({
  action,
  variables,
  setOpenVariable,
  variableRender,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.ADD-GROUP.";
  const [groupScope, setGroupScope] = useState("");
  const [groupType, setGroupType] = useState("");
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const setChangeFields = useSetRecoilState(changedFields);
  const changedFieldsState = useRecoilValue(changedFields);

  //SET default value 
  useEffect(() => {
    if (!action.fields.groupName) {
      action.fields.groupName = { value: '', isRequired: true };
    }
    if (!action.fields.groupType) {
      action.fields.groupType = { value: "" };
    }
    else {
      setGroupType(action.fields.groupType.value);
    }
    if (!action.fields.groupScope) {
      action.fields.groupScope = { value: "" };
    }
    else {
      setGroupScope(action.fields.groupScope.value);
    }
  }, [action.fields]);

  // changed group scope value
  function handleGroupScope(event) {

    const field = initialActionsData[action.id]?.fields["groupScope"];
    if (field) {
      const newValue = event.target.value;
      const oldValue = field.value
      CheckIfFlowUpdated("groupScope", action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
    }

    setGroupScope(event.target.value)
    action.fields.groupScope.value = event.target.value;
  }

  // changed group type value
  function handleGroupType(event) {
    const field = initialActionsData[action.id]?.fields["groupType"];
    if (field) {
      const newValue = event.target.value;
      const oldValue = field.value
      CheckIfFlowUpdated("groupType", action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
    }

    setGroupType(event.target.value)
    action.fields.groupType.value = event.target.value;
  }

  return (
    <div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "GROUP-NAME")} is_required={true} />
        <TextInput
          action={action}
          isRequired={true}
          inputName="groupName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          fieldType='string' displayName={t(label + 'GROUP-NAME')}
          hideRequired={true}
        />
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "DISTINGUISH-NAME")} />
        <TextInput
          action={action}
          isRequired={false}
          inputName="distinquishName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          fieldType='string' displayName={t(label + 'DISTINGUISH-NAME')}
        />
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "DESCRIPTION")} />
        <TextInput
          action={action}
          isRequired={false}
          inputName="description"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          fieldType='string' displayName={t(label + 'DESCRIPTION')}
        />
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "GROUP-SCOPE")} />
        <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
          <Select data-testid="group-scope" value={groupScope} onChange={handleGroupScope}>
            <MenuItem value="domainlocal">Domain Local</MenuItem>
            <MenuItem value="global">Global</MenuItem>
            <MenuItem value="universal">Universal</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "GROUP-TYPE")} />
        <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
          <Select data-testid="group-type" value={groupType} onChange={handleGroupType}>
            <MenuItem value="security">Security</MenuItem>
            <MenuItem value="distribution">Distribution</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
}
